import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
  })
export class SerializationHelperService {
     toInstance<T>(obj: T, json: string): T {

        let jsonObj = JSON.parse(json);

        if (typeof obj["fromJSON"] === "function") {
            obj["fromJSON"](jsonObj);
        } else {
            for (const propName of Object.keys(jsonObj)) { 
                obj[propName] = jsonObj[propName]
            }
        }
        return obj;
    }
}
